import api from './client';

export interface SocialProofSettings {
  enabled: boolean;
  show_customer_name: boolean;
  show_location: boolean;
  display_duration_seconds: number;
  display_interval_seconds: number;
}

export interface SocialProofEvent {
  id: number;
  customer_first_name: string | null;
  customer_location: string | null;
  product_title: string;
  occurred_at: string | null;
}

export const socialProofApi = {
  show: () => api.get<{ data: SocialProofSettings }>('/social-proof'),

  update: (settings: SocialProofSettings) =>
    api.put<{ data: SocialProofSettings }>('/social-proof', settings),

  events: (page = 1) =>
    api.get<{ data: SocialProofEvent[]; meta: { total: number; current_page: number; last_page: number } }>(
      `/social-proof/events?page=${page}`
    ),
};
